import { useMutation, UseMutationResult, useQuery, useQueryClient } from "@tanstack/react-query"
import * as DashboardService from "../service/Reporting"
import { Body_bu_dashboard_dashboard_business_unit_post, Body_get_invoice_complexity_report_data_dashboard_invoice_complexity_post, Body_get_invoices_operations_report_data_dashboard_invoices_operations_post, Body_supplier_dashboard_dashboard_supplier_post, Body_team_reviewer_dashboard_dashboard_team_reviewer_post } from "../api/generated";
import React from "react";

type InvoiceOperationsRequest = Body_get_invoices_operations_report_data_dashboard_invoices_operations_post;
type InvoiceComplexityRptRequest = Body_get_invoice_complexity_report_data_dashboard_invoice_complexity_post;

export const usePostReportingInvoiceOperations = () => {
  return useMutation({
    mutationFn: (filters:InvoiceOperationsRequest) => DashboardService.postReportingInvoiceOperations(undefined,undefined,undefined,undefined,filters),
  });
};

export const usePostInvoiceComplexityReport =() => {
  return useMutation({
    mutationFn: (filters:InvoiceComplexityRptRequest) => DashboardService.postInvoiceComplexityReport(undefined,undefined,undefined,undefined,filters),
  });
};

export const usePostBusinessUnitDashboardReport =() => {
  return useMutation({
    mutationFn: (filters:Body_bu_dashboard_dashboard_business_unit_post) => DashboardService.postBusinessUnitDashboardReport(undefined,undefined,undefined,undefined,filters),
  });
};

export const usePostSupplierDashboard =() => {
  return useMutation({
    mutationFn: (filters:Body_supplier_dashboard_dashboard_supplier_post) => DashboardService.postSupplierDashboardReport(undefined,undefined,undefined,undefined,filters),
  });
};

export const usePostTeamAndReviwerDashBoardRpt =() => {
  return useMutation({
    mutationFn: (filters:Body_team_reviewer_dashboard_dashboard_team_reviewer_post) => DashboardService.postTeamAndReviwerDashBoardRpt(undefined,undefined,undefined,undefined,filters),
  });
};

export const useGetAllSuppliers = () => {
  return useQuery({
    queryKey: ["SUPPLIERS"],
    queryFn: () => DashboardService.getAllSuppliers(),
    placeholderData: [],
  })
}
export const useGetBusinessUnitGlobalFilter = () => {
  return useQuery({
    queryKey: ["BUGLBFILTERS"],
    queryFn: () => DashboardService.getBusinessUnitGlobalFilter(),
    placeholderData: [],
  })
}
export const useGetSAupplierNameGlobalFilter = () => {
  return useQuery({
    queryKey: ["SUPPLIERNAMEGLBFILTERS"],
    queryFn: () => DashboardService.getSAupplierNameGlobalFilter(),
    placeholderData: [],
  })
}
export const useGetDashBoardInvoiceStatusList = () => {
  return useQuery({
    queryKey: ["INVOICESTATUSLIST"],
    queryFn: () => DashboardService.getDashBoardInvoiceStatusList(),
    placeholderData: [],
  })
}
export const useGetDashBoardRejectionReasonList = () => {
  return useQuery({
    queryKey: ["REJECTIONREASONLIST"],
    queryFn: () => DashboardService.getDashBoardRejectionReasonList(),
    placeholderData: [],
  })
}
export const useGetDashBoardInvoiceTypeList = () => {
  return useQuery({
    queryKey: ["INVOICETYPELIST"],
    queryFn: () => DashboardService.getDashBoardInvoiceTypeList(),
    placeholderData: [],
  })
}
export const useGetTeamsListsDashboardTeamsList = () => {
  return useQuery({
    queryKey: ["INVOICETEAM"],
    queryFn: () => DashboardService.getTeamsListsDashboardTeamsList(),
    placeholderData: [],
  })
}